import LatchkeyNamesParser from './LatchkeyNamesParser';

/**
 * Retrieves the selected latchkey for a given product, falling back to a default latchkey if none is selected.
 * @param {LatchKeyProduct} product - The product object
 * @param {Array<string>} latchkeyNames - An array of latchkey names
 * @return {string | null} The selected latchkey
 */
function getSelectedLatchkey(product, latchkeyNames) {
  const DEFAULT_LATCHKEY = 'Queen';
  const selectedLatchkey = product.relationships.selectedLatchKey || DEFAULT_LATCHKEY;

  return latchkeyNames.includes(selectedLatchkey) ? selectedLatchkey : (latchkeyNames[0] || null);
}

/**
 *
 * @param {LatchKeyProduct} [product]
 * @returns {string | null}
 */
export default function parser(product) {
  if (!product) {
    return null;
  }

  const latchkeyNames = LatchkeyNamesParser(product);
  return getSelectedLatchkey(product, latchkeyNames);
}
